// extracted by mini-css-extract-plugin
module.exports = {"toggleGroupContainer":"scroll-fab_toggleGroupContainer__XQnSz","toggleButton":"scroll-fab_toggleButton__jgPXI"};